const cepRegExp = /^\d{5}-\d{3}$/;

export const validCEP = (data) => cepRegExp.test(data);
